import HObject from '@/core/HObject.js'
import * as BABYLON from 'babylonjs'

export default class StandAlejandria extends HObject {
  constructor (hObject) {
    super(hObject.name, hObject.type, hObject.allowRegistration)
    this.init(hObject)
  }

  register () {
    let hObject = this
    this.registered = true

    BABYLON.SceneLoader.ImportMesh('', 'static/assets/StandAlejandria/', 'standAlejandriaX.babylon', window.scene, function (newMeshes, particleSystems) {
      hObject.objectConfigurations(newMeshes)

      // BABYLON.Tags.AddTagsTo(box, "box"

      // Disposes
      // newMeshes[8].dispose()
    })
  }
}



// WEBPACK FOOTER //
// ./src/hobjects/StandAlejandria.js